<script lang="ts">
  import { onMount } from "svelte";
  import Input from "../../components/Form/Fields/Input.svelte";
  import FormField from "../../components/Form/FormField.svelte";
  import GlobalErrors from "../../components/GlobalErrors.svelte";
  import SearchHeader from "../../components/SearchHeader.svelte";
  import Table from "../../components/Table/Table.svelte";
  import FormLayout from "../../layout/FormLayout.svelte";
  import { dossierCategoryFields } from "../../utils/TableFields/dossier-category.fields";
  import {
    editing,
    init,
    loading,
    onCreate,
    onDelete,
    onEdit,
    onPageChange,
    pagination,
    record,
    records,
    save,
  } from "./settings-dossier-categories.store";

  $: canSubmit = $record != null && !!$record.description;

  $: isNew = $record != null && $record.oid === 0;

  async function onSubmit() {
    await save();
    editing.set(false);
    record.set(null);
  }

  function onCancel() {
    editing.set(false);
    record.set(null);
  }

  onMount(init);
</script>

{#if $editing === false}
  <SearchHeader
    entitySingular="categoria pratica"
    entityPlural="categorie pratica"
    searchPlaceholder="cerca per descrizione"
    numRecords={$pagination != null ? $pagination.totalRecords : 0}
    searchFieldVisible={false}
  />

  <GlobalErrors errors={[]} />

  <div style="padding-bottom: 2rem;">
    <Table
      loading={$loading}
      fields={dossierCategoryFields}
      records={$records}
      pagination={$pagination}
      createEnabled={true}
      editEnabled={true}
      deleteEnabled={true}
      on:create={(_) => onCreate()}
      on:edit={(e) => onEdit(e.detail)}
      on:delete={(e) => onDelete(e.detail)}
      on:pageChange={(e) => onPageChange(e.detail)}
    />
  </div>
{:else if $record != null}
  <FormLayout on:submit={onSubmit} on:cancel={onCancel} {canSubmit} {isNew}>
    <FormField usageHelp="descrizione visibile (200 caratteri)">
      <Input
        name="Descrizione"
        placeholder="descrizione"
        required={true}
        maxlength={200}
        bind:value={$record.description}
      />
    </FormField>
  </FormLayout>
{/if}
